import { MarketingClientConstants } from "../constants/marketing-client-constants";
import { DOMHelper } from "../helpers/dom-helper";
import { Utils } from "./utils";


export class ErrorHandler {
    element: HTMLElement;
    errorElement: HTMLElement | null;
    errorElementSelector: string | null;
    dataErrorElementSelector = "data-error-selector";
    defaultMessage = "";

    constructor(element: HTMLInputElement) {
        this.element = element;
        this.errorElementSelector = element?.getAttribute(this.dataErrorElementSelector);
        this.errorElement = this.errorElementSelector ? DOMHelper.querySelector(`.${this.errorElementSelector}`) as HTMLElement : null;
    }

    setMessage(message: string): void {
        if (this.errorElement) {
            this.errorElement.innerHTML = (message || this.defaultMessage);
        }
    };

    show(message = ""): boolean {
        this.setMessage(message);

        Utils.showContainer(this.errorElement);
        this.element?.classList.add(MarketingClientConstants.hasErrorClassName);

        return false;
    }

    hide(): boolean {
        Utils.hideContainer(this.errorElement);
        this.element?.classList.remove(MarketingClientConstants.hasErrorClassName);

        return true;
    }
}
